import { PasswordStage } from './components/PasswordStage';
import { PersonalDetailsStage } from './components/PersonalDetailsStage';
import { SubscriptionStage } from './components/SubscriptionStage';
import { SuccessStage } from './components/SuccessStage';
import { SignUpStage } from './types';
import { useSignUp } from './useSignUp';

export const SignUpForm = () => {
  const { form, setForm, stage, setStage, loading, error, setError, signUp } = useSignUp();

  const commonProps = {
    form,
    setForm,
    setStage,
    error,
    setError,
    loading,
  };

  const renderStage = () => {
    switch (stage) {
      case SignUpStage.PERSONAL_DETAILS:
        return <PersonalDetailsStage {...commonProps} />;
      case SignUpStage.PASSWORD:
        return <PasswordStage {...commonProps} onNext={signUp} />;
      case SignUpStage.SUBSCRIPTION:
        return <SubscriptionStage {...commonProps} />;
      case SignUpStage.SUCCESS:
        return <SuccessStage {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex w-full h-full">
      {/* Left side could be added here if needed to match original layout's 50/50 split, currently assuming AuthHero handles the other half or this is just the right side */}
      {renderStage()}
    </div>
  );
};
